"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = void 0;
var _footer = require("@ori/footer");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const Footer = ({
  showFooterAboutSection = false
}) => {
  const lazyFooterProps = (0, _react.useMemo)(() => ({
    configuration: {
      isFrontPage: showFooterAboutSection,
      isStandalone: false,
      showFooterOnDesktop: true
    }
  }), [showFooterAboutSection]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_footer.FooterApp, {
    ...lazyFooterProps
  });
};
exports.Footer = Footer;
